import { db, storage } from "./firebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

// 상품 추가 함수
export const addProduct = async (
  productName,
  price,
  description,
  imageFile
) => {
  try {
    // 1️⃣ 이미지 Storage에 업로드
    const storageRef = ref(storage, `products/${imageFile.name}`);
    await uploadBytes(storageRef, imageFile);
    const imageUrl = await getDownloadURL(storageRef);

    // 2️⃣ Firestore에 상품 정보 저장
    const docRef = await addDoc(collection(db, "products"), {
      name: productName,
      price: Number(price),
      description,
      imageUrl, // Storage에 저장한 이미지 URL 추가
      createdAt: new Date(),
    });

    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("상품 추가 에러:", error.message);
    return { success: false, error: error.message };
  }
};
